import React from "react";

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(255, 255, 255, 0.7)", // translucent overlay
  zIndex: 9999, // on top of other elements
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const loaderStyle = {
  width: "25px",
  height: "25px",
  border: "8px solid #f3f3f3",
  borderTop: "8px solid #3498db", // color of the spinning "bar"
  borderRadius: "50%",
  animation: "spin 1s linear infinite",
};

function CustomLoader() {
  return (
    <div style={overlayStyle}>
      <div style={loaderStyle} />
      <style>
        {`
          @keyframes spin {
            0%   { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
}

export default CustomLoader;
